module.exports = __webpack_public_path__ + "static/media/defaultIMG.5979bacb.svg";